import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';

import { CmsDisclaimer, CmsTaxonomy, CmsTaxonomyGeneral } from '@fcom/core-api/interfaces';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

@Component({
  selector: 'fin-disclaimer',
  templateUrl: 'disclaimer.component.html',
  styleUrls: ['disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DisclaimerComponent {
  private themeService = inject(FinnairThemeService);

  disclaimer = input<CmsDisclaimer>();

  containerClasses = computed<string>(() => {
    const backgroundColor = this.disclaimer().backgroundColor
      ? `${this.disclaimer().backgroundColor}-bg`
      : 'nordic-blue-50-bg surface-secondary';
    const tags: CmsTaxonomy[] = this.disclaimer().subjectTaxonomyTags ?? [];
    const marginClass: string = tags.includes(CmsTaxonomyGeneral.MARGIN_SMALL)
      ? 'mr-small-b'
      : tags.includes(CmsTaxonomyGeneral.MARGIN_MEDIUM)
        ? 'mr-medium-b'
        : tags.includes(CmsTaxonomyGeneral.MARGIN_LARGE)
          ? 'mr-large-b'
          : '';
    return `${backgroundColor} ${marginClass}`;
  });

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);
}
